import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Modal } from '@material-ui/core'
import { ModalCard } from '../../components'
import { editUserEnd } from '../../state/SystemCache/actions'
import { getEditUser } from '../../state/SystemCache/selectors'
import { State } from '../../types'
import UserForm from '.'

type Props = {}

function UserFormModal(_props: Props) {
  const dispatch = useDispatch()

  const editUser = useSelector<State, { editing: boolean; userId: string }>(
    getEditUser,
  )

  return (
    <Modal open={editUser.editing} onClose={() => dispatch(editUserEnd())}>
      <ModalCard>
        <UserForm userId={editUser.userId} />
      </ModalCard>
    </Modal>
  )
}

export default UserFormModal
